export const mainContainerStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
};
export const passwordIconStyles = {
  position: "absolute",
  top: "42%",
  right: "13px",
  transform: "translateY(-50%)",
};
export const logoStyles = { width: "335.99px", height: "86px", color: "#00A7CD" };
export const textfieldStyles = {
  width: "100%",
  height: "48px",
  borderRadius: "8px",
  border: "2px solid #00A7CD",
  fontSize: "16px",
  padding: "12px",
};
export const forgotPasswordStyles = {
  textDecoration: "none",
  borderBottom: "none",
  color: "#9447AF",
};
export const loginButtonStyles = {
  width: "100%",
  height: "34px",
  borderRadius: "4px",
  backgroundColor: "#00A7CD",
};
